import React from 'react';
import OriginalEngineWorkspace from './OriginalEngineWorkspace';

export function OriginalEngineApp() {
  return <OriginalEngineWorkspace />;
}

export default OriginalEngineApp;
